module.exports = __webpack_public_path__ + "img/registration-certificate.fb6563b5.png";